export function hexToRGB(hex: string, alpha?: string) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  } else {
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  }
}

// ─────────────────────────────────────────────────────────────────
// Design tokens (JavaScript mirror of the `@theme` block in `src/styles/globals.css`)
//
// Use these when a colour is needed outside of Tailwind classes: chart
// libraries, map layers, canvas, inline SVG, email/PDF templates.
// For everything else use the semantic Tailwind classes
// (`bg-surface`, `text-fg-muted`, `border-border`, `bg-brand`, …).
//
// These values MUST stay in sync with `src/styles/globals.css`.
// ─────────────────────────────────────────────────────────────────

export const tokens = {
  surface: '#FFFFFF',
  surfacePage: '#F6F6F7',
  surfaceSunken: '#FAFAFA',
  surfaceHover: '#F5F5F5',
  surfaceInverse: '#1F1F1F',

  border: '#E6E6E6',
  borderStrong: '#D6D6D6',

  fg: '#1F1F1F',
  fgSecondary: '#525252',
  fgMuted: '#858585',
  fgInverse: '#FFFFFF',

  brand: '#F39322',
  brandHover: '#DD811A',
  brandText: '#AB6109',
  brandLink: '#E69840',
  brandLinkHover: '#DD811A',
  brandSubtle: '#FFF8F0',
  brandBorder: '#FDD5A4',

  positive: '#29C75A',
  positiveSubtle: '#EEFBF3',
  positiveText: '#1E7A33',

  negative: '#D61C1C',
  negativeSubtle: '#FEF2F2',
  negativeText: '#BC1919',

  info: '#3B82F6',
  infoSubtle: '#EFF6FF',
  infoText: '#1D4ED8',

  warning: '#F6A04A',
  warningSubtle: '#FEECD3',
  warningText: '#834B0A',

  transit: '#EAB308',
  transitSubtle: '#FEF9C3',
  transitText: '#854D0E',

  neutralSubtle: '#F5F5F5',
} as const;

// ── Raw scales ────────────────────────────────────────────────────
// Only for data visualisation (charts need several steps of one hue).
// Never use these for UI surfaces, borders or text — use `tokens`.

export const orange = {
  50: '#FFF8F0',
  100: '#FEECD3',
  200: '#FDD5A4',
  300: '#F9B972',
  400: '#F6A04A',
  500: '#F39322',
  600: '#E69840',
  700: '#AB6109',
  800: '#834B0A',
  900: '#62380B',
} as const;

/** Orange chart palette (darkest → lightest) for pie/bar charts */
export const CHART_COLORS = [orange[600], orange[400], orange[300], orange[200]] as const;

// ── helpers ───────────────────────────────────────────────────────
